// src/cert/iso20000.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO20000 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO/IEC 20000-1 प्रमाणन</h1>
                <p>आयटी सेवा व्यवस्थापन प्रणाली (IT Service Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>ISO/IEC 20000-1 म्हणजे काय?</h2>
                    <p>
                        ISO 20000-1 is right for any services supplier, giant or tiny, United National agency desires to produce assurance within the quality of the services they deliver. Its unremarkably used for IT services, facilities management and business services to assist guarantee effective and resilient services in todays ever-changing service delivery setting. Internationally recognized, ISO/IEC 20000-1 is that the best follow framework for a service management system that helps you to produce a regular, reliable service. It supports you to implant a service lifecycle strategy into you organization providing best follow steering on the way to manage your portfolio of services in order that they stay current and add prices.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>आयटी सेवा सातत्यपूर्ण आणि विश्वासार्ह होतात</li>
                        <li>डाउनटाइम, त्रुटी आणि तक्रारी कमी होतात</li>
                        <li>ग्राहक समाधान आणि SLA पूर्तता वाढते</li>
                        <li>खर्च नियंत्रण आणि संसाधन वापर सुधारतो</li>
                        <li>ITIL फ्रेमवर्कशी सुसंगतता</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO/IEC 20000-1 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO/IEC 20000-1" />
                </section>
            </div>
        </div>
    );
};

export default ISO20000;